import React, { useEffect } from 'react';

import { Table } from 'antd';
import moment from 'moment';
import queryString from 'query-string';

import { green } from '../../utils';
import { getReportStyles } from './SearchReport.helper';
import styles from './style.module.scss';

const WeeklyGainTableAntd = ({
  searchData,
  reportSubType,
  queryData,
  reportType,
  isLoading,
  onTableChange,
  sortDetail,
  y,
  visibleColumnsData,
  history,
}) => {
  const rows = [];

  const getOrder = (sortDetail = [], key = '') => {
    let order = false;
    let index = (sortDetail || []).findIndex((d) => d.sortBy === key);
    if (index > -1) {
      order =
        sortDetail[index].sortOrder === 'ASC'
          ? 'ascend'
          : sortDetail[index].sortOrder === 'DESC'
          ? 'descend'
          : false;
    }
    return order;
  };

  const columnsToShow = [
    {
      key: 'symbol',
      title: 'Symbol',
      value: 'Symbol',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'symbol'),
    },
    {
      key: 'sector',
      title: 'Sector',
      value: 'Sector',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'sector'),
    },
    {
      key: 'sec13dCount',
      title: 'SC 13D/G #',
      value: 'SC 13D/G #',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'sec13dCount'),
    },
    {
      key: 'year_start_price',
      title: 'Year Begin Price',
      value: 'Year Begin Price',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'year_start_price'),
    },
    {
      key: 'ytd',
      title: 'YTD',
      value: 'YTD',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'ytd'),
    },
    {
      key: 'no_of_weeks_past',
      title: 'Prev +ve Streak',
      value: 'Prev +ve Streak',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'no_of_weeks_past'),
    },
    {
      key: 'no_of_weeks_increased',
      title: 'No of Weeks Increased',
      value: 'No of Weeks Increased',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'Symbol'),
    },
    {
      key: 'lastSale',
      title: 'Last Sale',
      value: 'Last Sale',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastSale'),
    },
    {
      key: 'industry',
      title: 'Industry',
      value: 'Industry',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'industry'),
    },
  ];

  searchData.forEach((stockArray, stockIndex) => {
    const rowData = Object.fromEntries(
      stockArray.map((item) => [item.key, item.value]),
    );
    const symbol = rowData['symbol'];
    const numWeeks = parseInt(rowData['no_of_weeks_increased']) || 0;
    let totalGain = 0;
    let totalPriceDiff = 0;
    const extractAndFormatDate = (inputString) => {
      const dateStr = inputString.split('(')[0].trim();
      const date = moment(dateStr);
      return date.format('DD MMM YYYY');
    };
    const extractPrice = (priceString) => {
      const match = priceString.match(/\$(\d+(\.\d+)?)/); // Match the price value with the $ sign
      return match ? parseFloat(match[1]) : 0;
    };
    // Iterate through the weeks and calculate total gain and price diff
    for (let i = numWeeks; i >= 1; i--) {
      const weekData = rowData[`week_${i}`];
      if (!weekData) continue;
      const [gain, from, to, price] = weekData.split(',');

      const beginPriceValue = extractPrice(from);
      const endPriceValue = extractPrice(to);
      const beginPrice = `${extractAndFormatDate(from)}($${beginPriceValue})`;
      const endPrice = `${extractAndFormatDate(to)}($${endPriceValue})`;

      // Accumulate the total gain and price difference
      totalGain += parseFloat(gain);
      totalPriceDiff += parseFloat(price);

      // For each week, store the weekly gain and price diff
      rows.push({
        key: `${symbol}-${i}`,
        symbol: i === numWeeks ? symbol : '',
        weeklyGain:
          i === 1 ? (
            <>
              Week {numWeeks}: {beginPrice} → {endPrice}
              <br />
              Gain: {gain}%, PriceDiff: ${price}
              <br />
              <div className={styles.totalBorder}>
                <b>
                  Total Gain: {totalGain.toFixed(2)}%, Total Price Diff: $
                  {totalPriceDiff.toFixed(2)}
                </b>
              </div>
            </>
          ) : (
            `Week ${
              numWeeks + 1 - i
            }: ${beginPrice} → ${endPrice} Gain: ${gain}%, PriceDiff: $${price}`
          ),
        showSpan: i === numWeeks,
        span: numWeeks,
        ...rowData,
      });
    }
  });

  const renderWeeklyGain = (text) => (
    <div style={{ textAlign: 'center' }}>
      {text} {/* Render the JSX directly */}
    </div>
  );
  const filteredColumns = columnsToShow.filter((col) =>
    visibleColumnsData.some(
      (visibleCol) => visibleCol.key === col.key && visibleCol.visible,
    ),
  );

  const antdColumns = [
    {
      title: 'Symbol',
      dataIndex: 'symbol',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'Symbol'),
      align: 'center',
      render: (text, row) => ({
        children: (
          <p
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            style={{
              color: green,
              fontWeight: 700,
              lineHeight: '40px',
              cursor: 'Pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
            onClick={() => {
              let filters = {};
              filters = {
                type: 'SYMBOL'.toLowerCase(),
                subtype: 'INDIVIDUAL_STATISTICAL_REPORT'.toLowerCase(),
                symbols: text,
              };
              history.push(`/search/report/` + queryString.stringify(filters));
            }}
          >
            {text}
          </p>
        ),
        props: {
          rowSpan: row.showSpan ? row.span : 0,
        },
      }),
    },
    {
      title: <span className={styles.NonSortableColumn}>Weekly Gains</span>,
      dataIndex: 'weeklyGain',
      align: 'center',
      // className: styles.NonSortableColumn,
      width: 350,
      render: renderWeeklyGain,
    },
    ...filteredColumns
      .filter((col) => col.key !== 'symbol')
      .map((col) => ({
        title: col.title,
        value: col.key,
        dataIndex: col.key,
        sorter: true,
        sortDirections: ['descend', 'ascend'],
        sortOrder: getOrder(sortDetail, col.title),
        align: 'center',
        render: (text, row) => ({
          children:
            row.showSpan && col.key === 'ytd'
              ? `${text}%`
              : row.showSpan &&
                (col.key === 'year_start_price' || col.key === 'lastSale')
              ? `$${text}`
              : row.showSpan
              ? text
              : null,
          props: {
            rowSpan: row.showSpan ? row.span : 0,
          },
        }),
      })),
  ];
  useEffect(() => {}, [visibleColumnsData]);
  return (
    <>
      <Table
        style={getReportStyles({ reportSubType, queryData, reportType })}
        loading={isLoading}
        scroll={{ y: y }}
        columns={antdColumns}
        dataSource={rows}
        pagination={false}
        size="small"
        bordered={true}
        rowClassName={styles.tableHeader}
        className={styles.TabularData}
        showSorterTooltip={false}
        onChange={onTableChange}
        id="allPicksId"
      />
    </>
  );
};

export default WeeklyGainTableAntd;
